import { useEffect, useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import Brand from "./Brand";

const NAV = [
  { label: "Wat doen we", href: "#wat-doen-we" },
  { label: "Prijzen", href: "#prijzen" },
  { label: "Werk", href: "#werk" },
  { label: "Voor & na", href: "#voor-na" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-md border-b border-slate-200"
          : "bg-white"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center" data-testid="header-logo-link">
          <Brand size="md" />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm font-medium text-slate-700 hover:text-blue-700 transition-colors"
              data-testid={`nav-${n.href.slice(1)}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+31615460576"
            className="inline-flex items-center gap-2 px-5 h-11 rounded-full bg-orange-500 hover:bg-orange-600 text-white font-semibold transition-colors"
            data-testid="header-call-btn"
          >
            <Phone className="w-4 h-4" />
            06 154 60 576
          </a>
        </div>

        <button
          className="md:hidden p-2 rounded-md text-slate-700 hover:bg-slate-100"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-2 text-base font-medium text-slate-800"
                data-testid={`mobile-nav-${n.href.slice(1)}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href="tel:+31615460576"
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 h-12 rounded-full bg-orange-500 text-white font-semibold"
              data-testid="mobile-call-btn"
            >
              <Phone className="w-4 h-4" />
              06 154 60 576
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
